<template src='./productConfiguration.html'>
    
</template>
<script>
import { orderBy } from "@progress/kendo-data-query";
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("product");
import CommandCell from '@/components/CommandCellTemplate.vue';
import DialogBox from "@/components/DialogBox.vue";

export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "id", dir: "asc" }],
      columns: [
        { field: "code", title: "Product Code" },
        { field: "name", title: "Name" },
        { field: "description", title: "Description"},
        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      removeData:{}
    };
  },
  components: {
    DialogBox
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      this.removeData = item;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      return this.$store.dispatch("product/removeProduct", this.removeData.dataItem);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    edit: function(item) {
      return this.$store.dispatch("product/editProduct", item.dataItem); //item.dataItem.id
    },
    goToAddPage: function(){
      this.$router.push({name: "AddProduct", params: {add: true }})
    },
    async getDataOnload() {
      this.$store.dispatch("getProduct");
    }
  },
  computed: {
    //  ...mapState({
    //   productList: state => state.products,
    // }),
    productList() {
return this.$store.state.products
    },
    total() {
      return this.productList ? this.productList.length : 0;
    },
    items: {
      get: function() {
        return orderBy(this.productList.slice(this.skip, this.take + this.skip), this.sort);
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
